import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Programs from "@/components/Programs";
import Assessment from "@/components/Assessment";
import Results from "@/components/Results";
import JournalPreview from "@/components/JournalPreview";
import Faq from "@/components/Faq";
import CtaBanner from "@/components/CtaBanner";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      const t = setTimeout(() => {
        if (window.__lenis) {
          window.__lenis.scrollTo(`#${target}`, { offset: -72, duration: 1.4 });
        } else {
          document.getElementById(target)?.scrollIntoView({ behavior: "smooth" });
        }
      }, 250);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      data-testid="home-page"
    >
      <Hero />
      <Marquee />
      <Manifesto />
      <Programs />
      <Assessment />
      <Results />
      <JournalPreview />
      <Faq />
      <CtaBanner />
    </motion.main>
  );
};

export default Home;
